export const highlight = (str = '', sub = '') => {
  const start = str.toLowerCase().indexOf(sub.toLowerCase());
  if (start === -1) {
    return str;
  }
  const end = str.toLowerCase().indexOf(sub.toLowerCase()) + sub.length;
  return str.slice(0, start)
    .concat(`<div>${str.slice(start, end)}</div>`)
    .concat(str.slice(end, str.length[str.length - 1]));
};



// WEBPACK FOOTER //
// ./src/shared/utils/formatter.js